import axios from "axios";
import { getToken } from "@/lib/authStorage";

function defaultBackendUrl() {
  if (typeof window === "undefined") return "http://127.0.0.1:8000";
  const { protocol, hostname, port, origin } = window.location;
  if ((hostname === "127.0.0.1" || hostname === "localhost") && port === "3000") {
    return `${protocol}//${hostname}:8000`;
  }
  return origin;
}

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || defaultBackendUrl()).replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const COVER_FALLBACKS = [
  "https://images.unsplash.com/photo-1736882178500-f99bbe22d77d?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1618172842918-3eabce30c912?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1676068368612-1c8b3e2afed0?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.pexels.com/photos/15578032/pexels-photo-15578032.png?auto=compress&cs=tinysrgb&w=600",
];

export function coverFor(track) {
  if (track?.cover_url) return track.cover_url;
  const seed = (track?.id || "").charCodeAt(0) || 0;
  return COVER_FALLBACKS[seed % COVER_FALLBACKS.length];
}

export function formatTime(s) {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, "0")}`;
}
